export default __webpack_public_path__ + "static/media/disabledPieChartDshTab.e326e691.svg";